import PropTypes from 'prop-types'
import React from 'react'

import { fullName } from 'services/invitation_helpers'
import { fullName as userFullName } from 'services/user_helpers'
import { pluralize } from 'services/utils'

import styles from './guest-name.scss'

// Render the name of the guest. Typically used on the GuestList
// Note: the invitation is optional. If it is not provided then the user's name
// is used instead
export default class GuestName extends React.Component {
  _renderAdultAndChildCount () {
    const { invitation } = this.props
    if (!invitation) return null

    let text = ''
    // TODO: Maybe share code with GuestCountControls
    if (invitation.guest_count > 0) {
      text += `+ ${invitation.guest_count} ${pluralize(invitation.guest_count, 'adult')} `
    }
    if (invitation.child_count > 0) {
      text += `+ ${invitation.child_count} ${pluralize(invitation.child_count, 'child')}`
    }

    return (
      <div className={styles['adult-and-child-count']}>
        {text}
      </div>
    )
  }

  _renderGuestCounts () {
    const {
      invitation,
      guestCountEnabled,
      childCountEnabled
    } = this.props

    const hasAdditionalGuests = invitation && invitation.guest_count > 0
    const invitationAccepted = invitation && invitation.rsvp_state === 'accepted'

    const showAdditionalGuestCount = guestCountEnabled && !childCountEnabled && hasAdditionalGuests && invitationAccepted
    const showAdultAndChildCount = guestCountEnabled && childCountEnabled && invitationAccepted

    return (
      <span>
        {showAdultAndChildCount
          ? this._renderAdultAndChildCount()
          : null}
        {showAdditionalGuestCount
          ? <span className={styles['guest-count']}>+ {invitation.guest_count}</span>
          : null}
      </span>
    )
  }

  render () {
    const {
      invitation,
      guestName,
      user
    } = this.props

    const userName = invitation ? fullName(invitation, user) : userFullName(user)
    const name = guestName || userName

    return (
      <div className={styles['guest-body']}>
        <span>
          {name}
        </span>
        {invitation ? this._renderGuestCounts() : null}
      </div>
    )
  }
}

GuestName.propTypes = {
  invitation: PropTypes.object,
  user: PropTypes.object,
  // Guest name overrides the name from user
  guestName: PropTypes.string,
  guestCountEnabled: PropTypes.bool,
  childCountEnabled: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/guest_list/GuestName.jsx